module.exports = __webpack_public_path__ + "static/media/3DPPA12.49a62f2d.jpg";